import React, {useEffect} from "react";
import {refocusOnPageChange, useDocumentTitle} from "./landmarksUtility";

interface PageTitleProps {
    children?: React.ReactNode;
    className?: string;
    h1: string;
    hasBorder?: boolean;
    isCentered?: boolean;
    isDocumentTitle?: boolean;
}

export const PageTitle: React.FC<PageTitleProps> = ({children, className = "", h1, hasBorder, isCentered, isDocumentTitle = true}: PageTitleProps) => {

    let classes = className;
    classes += " pageTitle ";
    classes += hasBorder ? " pageTitle--border " : "";
    classes += isCentered ? " pageTitle--center " : "";

    useDocumentTitle(isDocumentTitle ? h1 : "");

    useEffect(refocusOnPageChange, [h1]);

    return (
        <header className={classes}>
            <h1>{h1} <span id={"extraScreenReaderContent"} className={"show-for-sr"}/></h1>
            <div className={`h2`}>{children}</div>
        </header>
    );
};
